<template>
  <a-input
      v-show="info.status === 'edit'"
      v-model:value="data[propName]"
      :placeholder="'请填写' + info.title"
  />
  <div v-show="info.status === 'show'" class="view">
    <div class="show-box">{{ data[propName] || '' }}</div>
  </div>
</template>

<script lang="ts">

import {definedWidgetMeta} from "@/components/business/crud/widgets/widgetManager";

export const meta = definedWidgetMeta({
  size: {edit: 'normal', show: 'normal'},
});
</script>

<script lang="ts" setup>
import {defineProps} from 'vue';
import {ScForm} from "@/models/ScForm";
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {UrlFieldType} from "@/components/business/crud/interface/FieldType";

const props = defineProps<{
  propName: string;
  widget: UrlFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

function ellipsis(text: string, max: number) {
  if (text.length <= max) {
    return text;
  } else {
    return text.slice(0, max - 3) + "..."
  }
}
</script>


<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}
.show-box {
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: $font-size-small;
}
</style>
